import { render, staticRenderFns } from "./MsLabelRequire.vue?vue&type=template&id=2aeaf8f4"
import script from "./MsLabelRequire.vue?vue&type=script&lang=js"
export * from "./MsLabelRequire.vue?vue&type=script&lang=js"
import style0 from "./MsLabelRequire.vue?vue&type=style&index=0&id=2aeaf8f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports